// @ts-nocheck
import type { StatelessFunctionalComponent } from 'react';
import styled from 'styled-components';
import { getTheme } from 'settings/theme/index';
import { TABLET_SMALL_WIDTH } from 'commons/constants/size';

const {
  palette: { greyscale, primary, neutral },
  noodera: { fontTypes, spacing },
  gradients,
} = getTheme();
export const Wrapper: StatelessFunctionalComponent<any> = styled.div`
  width: 100%;
  background: ${greyscale.white};
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: column;
`;
export const Container: StatelessFunctionalComponent<any> = styled.div`
  width: 100%;
  padding-top: ${spacing.x3};
  padding-bottom: ${spacing.x3};
  max-width: 432px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media only screen and (max-width: ${TABLET_SMALL_WIDTH}px) {
    max-height: unset;
    padding: ${spacing.x5};
  }
`;
export const TitleContainer: StatelessFunctionalComponent<any> = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  margin-bottom: ${spacing.x5};
`;
export const StyledTitle: StatelessFunctionalComponent<any> = styled.h3`
  ${fontTypes.font4Medium};
  color: ${neutral.hundred};
  margin-bottom: 0;
`;
export const ChangeSectionTypeText: StatelessFunctionalComponent<any> = styled.p`
  ${fontTypes.font5Medium};
  color: ${primary.hundred};
  border: 1px solid ${primary.hundred};
  border-radius: 12px;
  padding: 0px ${spacing.x6};
  cursor: pointer;
  margin-bottom: 0;

  &:hover {
    background: ${gradients.noodera};
    color: ${greyscale.white};
  }
`;
export const SectionTitle: StatelessFunctionalComponent<any> = styled.h3`
  ${fontTypes.font4Medium};
  color: ${neutral.eighty};
  margin-bottom: ${spacing.x3} 0 ${spacing.x7};
`;
export const DatepickerContainer: StatelessFunctionalComponent<any> = styled.div`
  margin: ${spacing.x3} 0;
`;
export const Section: StatelessFunctionalComponent<any> = styled.div`
  && {
    margin-bottom: ${spacing.x3};
    text-align: left;

    & > button {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 48px;
    }

    @media only screen and (max-width: ${TABLET_SMALL_WIDTH}px) {
      & > div {
        margin: 0 -${spacing.x5} 0 0;
      }
    }
  }
`;
export const Text: StatelessFunctionalComponent<any> = styled.span`
  ${fontTypes.font4};
  color: ${neutral.hundred};
`;
export const TextBold: StatelessFunctionalComponent<any> = styled.span`
  ${fontTypes.font4Medium};
  color: ${primary.hundred};
  cursor: pointer;
`;
export const NoItems: StatelessFunctionalComponent<any> = styled.div`
  && {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: ${spacing.x6} 0 ${spacing.x4};

    & > span:nth-child(2) {
      ${fontTypes.font3Medium};
      color: ${neutral.hundred};
      margin: ${spacing.x6} 0;
    }

    & > span:nth-child(3) {
      ${fontTypes.font4};
      color: ${neutral.hundred};
      margin: ${spacing.x6} 0;
    }

    & > div {
      display: flex;
      flex-grow: 1;
      width: 100%;
      justify-content: space-between;

      & > .btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 212px;
        height: 48px;
      }
    }

    @media only screen and (max-width: ${TABLET_SMALL_WIDTH}px) {
      & > span:nth-child(3) {
        text-align: center;
      }

      & > div {
        flex-direction: column;

        & > .btn {
          width: 100%;
          margin-bottom: ${spacing.x6};
        }
      }
    }
  }
`;
